import { CoachProfile } from "@joonapp/web-shared"

import { useCoachingGroupsQuery } from "../networking/coachingGroups/queries"
import { useUserQuery } from "../networking/user/queries"

export const useCoachingProfile = () => {
  const { data: user } = useUserQuery()
  const { data: coachingGroups } = useCoachingGroupsQuery()
  const coachingProfile = coachingGroups?.[0]?.profiles.find(
    (profile: any) => profile.user.id === user?.id
  )

  return coachingProfile as CoachProfile | undefined
}

export default useCoachingProfile
